class CounterUp extends HTMLElement {
    constructor() {
        super();
        this.startValue = 0;
        this.endValue = parseInt(this.getAttribute('count-to')) || 0;
        this.duration = parseInt(this.getAttribute('duration')) || 2000;
        this.observer = null;
        this.counterDiv = null;
        this.counterSpan = null;
    }

    connectedCallback() {
        this.render();
        this.setupObserver();
    }

    render() {
        // Create the div and span where the counter value will be displayed
        this.counterDiv = this.querySelector('.counter-number');
        if (!this.counterDiv) {
            this.counterDiv = document.createElement('div');
            this.counterDiv.classList.add('counter-number');
            this.appendChild(this.counterDiv);
        }
        
        this.counterSpan = this.counterDiv.querySelector('.counter-span');
        if (!this.counterSpan) {
            this.counterSpan = document.createElement('span');
            this.counterSpan.classList.add('counter-span');
            this.counterDiv.appendChild(this.counterSpan);
        }
        
        this.counterSpan.textContent = this.startValue;
    }

    setupObserver() {
        const options = {
            root: null, // relative to the viewport
            rootMargin: '0px',
            threshold: 0.1 // start when 10% of the element is visible
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.startCounting();
                    this.observer.disconnect(); // Stop observing after counting starts
                }
            });
        }, options);

        this.observer.observe(this);
    }

    startCounting() {
        const startTime = performance.now();
        const updateCounter = (currentTime) => {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / this.duration, 1);
            const currentValue = Math.floor(progress * (this.endValue - this.startValue) + this.startValue);

            this.counterSpan.textContent = currentValue;

            if (progress < 1) {
                requestAnimationFrame(updateCounter);
            }
        };

        requestAnimationFrame(updateCounter);
    }
}

customElements.define('counter-up', CounterUp);

document.addEventListener('shopify:section:load', (event) => {
    const section = event.target; // The section that was added
    const counters = section.querySelectorAll('counter-up'); // Select all counter-up elements in the section
    
    // Initialize each counter-up component
    counters.forEach(counter => {
        counter.startCounting(); // Start the counting animation immediately
    });
});